import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const studyReportFields: FieldInterface[] = [
  {
    key: 'result',
    originKey: 'result',
    objectType: 'StudyReportResult',
    objectTypePath: 'src/global-types',
    type: FIELD_TYPES.object,
  },
]

const studyReportRelations: RelationInterface[] = []

export { studyReportFields, studyReportRelations }
